const toggleSections = Array.from(document.querySelectorAll('.js-toggle-section'));

toggleSections.forEach((section) => {
    section.addEventListener('click', () => {
        document.getElementById(`card-accordion-${section.dataset.id}`).classList.toggle('toggled');
    });
});
